import i18n from '@i18n';
import { parseAmount } from '@utils';
import { VALIDATE_OBJECT, Yup } from '@validations';

export const SNACKBAR_DURATION = 2000;

/**
 * Dynamicaly generates a validation schema limiting the max amount to total balance and omits validations if its a full recovery
 * @param {number} options.totalBalance The total balance of the account
 * @param {boolean} options.fullRecovery The total balance of the account
 *
 */
export const BALANCE_RETRIEVE_VALIDATION = ({
  totalBalance,
  fullRecovery,
}: {
  totalBalance: number;
  fullRecovery: boolean;
}) => {
  if (fullRecovery) return;

  const helperText = i18n.t('EMPLOYEES:DETAIL:VALIDATIONS:AMOUNT_EXCEEDS_TOTAL_BALANCE', {
    totalBalance: parseAmount(totalBalance),
  });

  return VALIDATE_OBJECT({
    amount: Yup.string()
      .required('COMMON:VALIDATIONS:REQUIRED_FIELD')
      .transform((value) => value.replace(',', '.'))
      .matches(/^\d+(\.\d+)?$/, 'COMMON:VALIDATIONS:INVALID_AMOUNT')
      .min(1, 'COMMON:VALIDATIONS:INVALID_AMOUNT')
      .test(
        'is-number',
        'COMMON:VALIDATIONS:INVALID_AMOUNT',
        (value) => !isNaN(parseFloat(value ?? ''))
      )
      .test('checkDecimals', 'COMMON:VALIDATIONS:INVALID_AMOUNT_DECIMALS', (num) => {
        const decimals = String(num).split('.')[1];

        if (String(num)?.includes(',')) {
          return false;
        }
        if (!decimals) {
          return true;
        } else {
          return decimals.length < 3;
        }
      })
      .test('checkMax', helperText, (num) => {
        return Number(num) <= totalBalance;
      }),
  });
};
